<form [formGroup]="siteForm" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
  <textarea rows="12" cols="120" formControlName="site_notes"></textarea>
  @if (siteForm.dirty && !readOnly) {
    <div class="btn-group">
      <button class="btn no" (click)="cancelChanges()">
        {{ "Cancel" | translate }}
      </button>
      <button class="btn" type="submit">
        {{ "Save" | translate }}
      </button>
    </div>
  }
</form>
